import { AfterViewInit, Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { ContextMenuButton, RadialMenuOrientation } from '../../models/contextmenu.model';

@Component({
    selector: 'app-contextmenu',
    templateUrl: './contextmenu.component.html',
    styleUrls: ['./contextmenu.component.scss'],
    standalone: false
})
export class ContextmenuComponent implements AfterViewInit {
  @ViewChild('radialContainer', { static: false }) radialContainer: ElementRef;
  @ViewChild('radialMenu', { static: false }) radialMenu: ElementRef;
  @ViewChild('radialPlus', { static: false }) radialPlus: ElementRef;

  @Input('buttons') buttons: ContextMenuButton[];
  @Input('orientation') orientation: RadialMenuOrientation;
  @Input('buttonSizePixels') buttonSizePixels: number;
  @Input('diameterPixels') diameterPixels: number;
  @Input('backgroundVisible') backgroundVisible: boolean;

  @Output() radClick = new EventEmitter();
  @Output() contextMenuClosed = new EventEmitter();

  public active: boolean = true;

  constructor() {
    this.orientation = RadialMenuOrientation.radial;
    this.backgroundVisible = true;
    this.diameterPixels = 100;
  }

  public openRadialMenu(): void {
    if (this.radialMenu.nativeElement.children.length === 0) {
      this.closePopup();
      return;
    }
    this.radialPlus.nativeElement.style.transform = 'rotate(45deg)';
    this.radialContainer.nativeElement.style.visibility = 'visible';
    const popupElement = this.radialContainer.nativeElement.parentElement?.parentElement;
    if (popupElement) popupElement.style.zIndex = 99999;
  }

  public menuClick(event: any): void {
    event.stopPropagation();
    this.closePopup();
  }

  private closePopup() {
    this.radialContainer.nativeElement.style.visibility = 'hidden';
    this.contextMenuClosed.emit();
  }

  public isVisible(): boolean {
    return this.radialContainer?.nativeElement?.style?.visibility == 'visible';
  }

  ngAfterViewInit(): void {
    this.customizeSubmenus();
  }

  public customizeSubmenus(): void {
    if (this.radialMenu.nativeElement.children.length === 0) {
      return;
    }

    let containerRadius = this.diameterPixels / 2;
    let buttonCount: number = this.radialMenu.nativeElement.children.length;
    var maxImageSize = this.buttonSizePixels == undefined ? this.diameterPixels / 4 : this.buttonSizePixels;

    if (buttonCount > 7) {
      maxImageSize *= 7 / buttonCount;
    }

    let cancelSizePixels = maxImageSize / 3;

    this.radialContainer.nativeElement.style.marginLeft = -containerRadius + 'px';
    this.radialContainer.nativeElement.style.marginTop = -containerRadius + 'px';
    this.radialContainer.nativeElement.style.width = 2 * containerRadius + 'px';
    this.radialContainer.nativeElement.style.height = 2 * containerRadius + 'px';

    this.radialMenu.nativeElement.style.marginLeft = -containerRadius + 'px';
    this.radialMenu.nativeElement.style.marginTop = -containerRadius + 'px';
    this.radialMenu.nativeElement.style.position = 'absolute';
    this.radialMenu.nativeElement.style.left = '0px';
    this.radialMenu.nativeElement.style.top = '0px';
    this.radialMenu.nativeElement.style.width = 2 * containerRadius + 'px';
    this.radialMenu.nativeElement.style.height = 2 * containerRadius + 'px';

    this.radialPlus.nativeElement.style.width = cancelSizePixels + 'px';
    this.radialPlus.nativeElement.style.height = cancelSizePixels + 'px';
    this.radialPlus.nativeElement.style.textAlign = 'center';
    this.radialPlus.nativeElement.style.fontSize = cancelSizePixels + 'px';

    if (this.backgroundVisible === false) {
      this.radialContainer.nativeElement.style.background = 'rgba(255,255,255, 0)';
      this.radialContainer.nativeElement.style.border = 'none';
      this.radialMenu.nativeElement.style.background = 'rgba(255,255,255, 0)';
      this.radialMenu.nativeElement.style.border = 'none';
    }

    var abst = -maxImageSize / 8;

    var buttonRadius = containerRadius - maxImageSize / 2 + abst;
    var angle = (2.0 * Math.PI) / buttonCount;

    let counter = 0;

    let topX: number;
    let topY: number;
    for (let child of this.radialMenu.nativeElement.children) {
      if (this.orientation == RadialMenuOrientation.radial) {
        var curAngle = counter * angle;
        topY = containerRadius + buttonRadius * -Math.cos(curAngle);
        topX = containerRadius + buttonRadius * Math.sin(curAngle);
        this.radialContainer.nativeElement.style.borderRadius = '50%';
        this.radialMenu.nativeElement.style.borderRadius = '50%';
        this.radialPlus.nativeElement.style.borderRadius = '50%';
        this.radialPlus.nativeElement.style.position = 'absolute';
        this.radialPlus.nativeElement.style.top = '0px';
        this.radialPlus.nativeElement.style.marginLeft = -cancelSizePixels / 2 + 'px';
        this.radialPlus.nativeElement.style.marginTop = -cancelSizePixels / 2 + 'px';
      } else if (this.orientation == RadialMenuOrientation.right) {
        topX = maxImageSize;
        var top0 = 0 + 0.5 * maxImageSize - ((maxImageSize + abst) * buttonCount) / 2;
        topY = top0 + counter * (maxImageSize + abst);
      } else if (this.orientation == RadialMenuOrientation.left) {
        topX = -1.5 * maxImageSize;
        var top0 = 0 + 0.5 * maxImageSize - ((maxImageSize + abst) * buttonCount) / 2;
        topY = top0 + counter * (maxImageSize + abst);
      } else if (this.orientation == RadialMenuOrientation.top) {
        var topX0 = 0 + 0.5 * maxImageSize - ((maxImageSize + abst) * buttonCount) / 2;
        topX = topX0 + counter * (maxImageSize + abst);
        topY = -maxImageSize;
      } else if (this.orientation == RadialMenuOrientation.bottom) {
        var topX0 = 0 + 0.5 * maxImageSize - ((maxImageSize + abst) * buttonCount) / 2;
        topX = topX0 + counter * (maxImageSize + abst);
        topY = maxImageSize;
      }

      child.style.position = 'absolute';
      child.style.marginLeft = -maxImageSize / 2 + 'px';
      child.style.marginTop = -maxImageSize / 2 + 'px';
      child.style.width = maxImageSize + 'px';
      child.style.height = maxImageSize + 'px';
      child.style.left = topX + 'px';
      child.style.top = topY + 'px';
      for (let button of child.children) {
        button.style.width = maxImageSize + 'px';
        button.style.height = maxImageSize + 'px';
        button.style.backgroundSize = maxImageSize * 0.6 + 'px ' + maxImageSize * 0.6 + 'px';
        button.style.backgroundPosition = '50% 50%';
        button.style.backgroundRepeat = 'no-repeat';
        button.style.backgroundAttachment = 'scroll';
      }

      counter++;
    }
  }

  public onRadClick(btn: ContextMenuButton) {
    var args = { button: btn };
    this.radClick.emit(args);
  }
}
